import { FormatHelper } from '@adp-wfn/mdf-core';
import { WfnRadioGroup } from '@adp-wfn/mdf-wc-react';
import React, { useCallback, useMemo } from 'react';
import { Field } from './types';

const YES_VALUE = 'yes';
const NO_VALUE = 'no';

/**
 * Yes/No boolean field component (radio buttons)
 * @param props - Field component props
 * @param props.id - Unique field identifier
 * @param props.data - Field configuration with boolean value
 * @param props.onChange - Callback function for value changes
 * @returns JSX element for Yes/No field
 */
export function YesNo({ id, data, onChange }: Field) {
  const selectedValue = useMemo(() => {
    if (data.value === true) {
      return YES_VALUE;
    }
    if (data.value === false) {
      return NO_VALUE;
    }
    return undefined;
  }, [data.value]);

  const handleChange = useCallback(
    (event: any) => {
      const value = event?.detail?.value;
      if (value === YES_VALUE) {
        onChange(true);
      }
      else if (value === NO_VALUE) {
        onChange(false);
      }
      else {
        onChange(undefined);
      }
    },
    [onChange]
  );

  const radioItems = useMemo(
    () => [
      {
        id: 'yes',
        value: YES_VALUE,
        label: FormatHelper.formatMessage('@@Yes')
      },
      {
        id: 'no',
        value: NO_VALUE,
        label: FormatHelper.formatMessage('@@No')
      }
    ],
    []
  );

  return (
    <WfnRadioGroup
      id={id}
      items={radioItems}
      label={data.label}
      tooltipText={data.tooltipText}
      value={selectedValue}
      onSdfChange={handleChange}
    />
  );
}
